<template>
  <v-text-field v-if="model" v-model="model.value" v-bind="theProps" v-on:input="inputChange" />
</template>


<script>
  export default {
    props: ['value', 'theProps'],
    data() {
      return {
      }
    },
    computed: {
      model: function() {
        if(this.value != null) {
          if(this.value.value != null && this.value.value != undefined) {
            return this.value
          }
        }
        return null
      }
    },
    methods: {
      inputChange: function(event) {
        this.$emit('update-fields');
      }
    }
  }
</script>